var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialOutlinePintrest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8a8 8 0 00-4.484 14.626l3.57-8.032a1 1 0 111.828.812l-1.143 2.571c.347.708.922 1.023 1.479 1.023 1.497 0 2.75-1.085 2.75-3v-.001a4 4 0 10-7.76 1.36 1 1 0 01-1.88.682 6.001 6.001 0 019.502-6.639 6 6 0 012.138 4.6L21 16h1v.001C22 18.977 19.894 21 17.25 21a3.483 3.483 0 01-2.399-.953l-1.55 3.486A8 8 0 1016 8zM6 16c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10S6 21.523 6 16z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social-outline--Pintrest-6d4cdb30cfdf46600531824fb2277f83.svg";
export { SvgIconSocialOutlinePintrest as Component };